import { handleRequest } from './base';

// UserRepo is used to retrieve auth
const UserRepo = {
  authURL: () => handleRequest(
    {
      method: 'get',
      url: '/auth',
    },
    false,
  ),

  authConfirm: (val) => handleRequest(
    {
      method: 'get',
      url: '/auth/confirm',
      params: val,
    },
    false,
  ),

  fetch: () => handleRequest(
    {
      method: 'get',
      url: '/user',
    },
    false,
  ),

  addKey: (key) => handleRequest({
    method: 'post',
    url: '/user/keys',
    data: { key },
  }),
};

export default UserRepo;
